// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1bdea79","455":"5a542a34","488":"29c45b55","977":"877d4770"}[chunkId] + ".chunk.js";
};